<ng-container [ngSwitch]="currentView">
  @if (singlePlanMode && (activeTab === 'business' || activeTab === 'ecommerce') && !mode) {
    <!-- BUSINESS/ECOMMERCE VIEW -->
    <div *ngSwitchCase="'business'" class="db-business-ecommerce"
         [ngClass]="{'fade-out': showAgencyTab, 'fade-in': !showFirstTime}">
      <div class="db-single-plan-container" [ngClass]="{'active': animateSinglePlan && !static, 'static': static}">
        <div class="db-one-week-free-demo">
          <div class="db-one-week-free-demo__header single-mode">
            <div class="content">
              <p class="sub-header">Try 10Web Pro</p>
              @if ((campaignInfo?.couponDays || couponDays) > 7) {
                <h1 class="db-days-lined">7 days</h1>
              }
              <h1>
                {{ !!campaignInfo ? (campaignInfo?.couponDays == 30 ? '1 month ' : campaignInfo?.couponDays + ' days') : '7 days ' }}  Free
              </h1>
            </div>

            <div class="db-see-agency-plans" (click)="seeAgencyTab(); addOwnWorkspace()">
              <i class="db-icon db-icon-ds-building"></i>
              <span>See Agency Plans (2+ websites)</span>
            </div>
          </div>
          <div class="db-has-campaign-coupon mt24" *ngIf="hasCouponForCampaign && (!!campaignInfo?.couponPercent || couponPercent)">
            Enjoy <span class="coupon-discount ml3 mr3">{{ campaignInfo?.couponPercent || couponPercent }}% off</span>
            on your first payment
          </div>
          <div class="db-single-mode-price-content {{hasCouponForCampaign ? 'mt16' : 'mt40'}} mb32">

            <div class="db-header">
              <div class="db-header-text">
                <h2><i class="db-icon db-icon-ds-diamond-new"></i>10Web Pro</h2>
                <p>Plus, get free custom domain</p>
              </div>
              <div class="db-header-price">
                <p>{{ !!campaignInfo ? (campaignInfo?.couponDays == 30 ? '1 month ' : campaignInfo?.couponDays + ' days') : couponDays ? couponDays + ' days' : '7 days ' }}
                  free</p>
                <p class="db-month" *ngIf="subscriptionsTabs && subscriptionsTabs[activeTab]">
                    <span *ngIf="hasCouponForCampaign && (!!campaignInfo?.couponPercent || couponPercent)" class="db-lined">
          ${{
                        (subscriptionsTabs[activeTab][0]?.plan?.planPrice / periodSwitch) | DbNumberFormatPipe:
                          periodSwitch === 12 || applyCouponForPlatform ? 'ceil' : 'floor'
                      }}
        </span>
                  ${{
                    (subscriptionsTabs[activeTab][0]?.plan?.planPrice * (100 - couponPercent) / 100) /
                    periodSwitch | DbNumberFormatPipe:
                      hasCouponForCampaign ? 'precise' : 'floor'
                  }}<span>/month</span></p>
              </div>
            </div>
            <!-- Period Switch Component -->
            <div class="db-period-switch-coupon db-upgrade-plan__period-switch db-single-mode-switch">
              <input class="ds-switcher-green ds-control-small"
                     type="checkbox"
                     title="Toggle Annual Discount"
                     [id]="'annual'"
                     [checked]="periodSwitch === 12">
              <label [for]="'annual'"
                     (click)="$event.preventDefault(); changePeriod()">
                <span class="ds-switcher-control"></span>
                <p [class.monthly]="periodSwitch === 1">Annual discount (50%)</p>
              </label>
            </div>
          </div>
        </div>

        <!-- Subscription Plans -->
        <div class="db-one-week-free-demo__content {{activeTab}}">
          <ng-container *ngIf="subscriptionsTabs && subscriptionsTabs[activeTab]">
            <ng-container *ngFor="let subscription of subscriptionsTabs[activeTab]; let i = index">
              <db-one-week-free-demo-plan
                [singlePlanMode]="singlePlanMode"
                [hasCampaignCoupon]="hasCouponForCampaign && !mode"
                [showFirstTime]="showFirstTime"
                [isEcommerceWebsite]="isEcommerceWebsite"
                [title]="subscription?.plan?.title"
                [applyCouponForPlatform]="applyCouponForPlatform"
                [couponPercent]="couponPercent"
                [domainName]="domainName"
                [hasFreeDays]="hasFreeDays"
                [description]="planFeatures[activeTab][subscription?.category]?.desc"
                [subscription]="subscription"
                [periodSwitchValue]="periodSwitch"
                [plan]="planFeatures[activeTab][subscription?.category]?.planInfo"
                [planDesc]="planFeatures[activeTab][subscription?.category]?.planInfoDesc"
                [mostPopular]="!!planFeatures[activeTab][subscription?.category]?.mostPopular"
                [professionalInfo]="!!planFeatures[activeTab][subscription?.category]?.info"
                [isAgency]="activeTab === 'agency'"
                [activeTab]="activeTab"
                [customDomainFlow]="customDomainFlow"
                [isSelected]="singlePlanMode || selectedPlanId === subscription.id">
              </db-one-week-free-demo-plan>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="trustpliot-single" *ngIf="!showFirstTime">
        <db-trustpilot [version]="'micro-combo'"></db-trustpilot>
      </div>
    </div>

    <div class="db-single-plan-checkout" *ngSwitchCase="'business'"
         [ngClass]="{'fade-out': showAgencyTab, 'fade-in': !showFirstTime && animateSinglePlan}">
      <db-one-month-free-checkout-demo
        *ngIf="chosenPlan && !showFirstTime"
        class="db-mixed-checkout"
        (onClose)="closeModal($event)"
        [singlePlanMode]="singlePlanMode"
        [userSubscription]="userSubscription"
        [user]="user"
        [demoUser]="demoUser"
        [chosenPlan]="chosenPlan"
        [couponCode]="couponCode"
        [couponPercent]="campaignInfo?.couponPercent || couponPercent"
        [couponDays]="campaignInfo?.couponDays || couponDays || 7"
        [hasCampaignCoupon]="hasCouponForCampaign && (chosenPlan?.category !== UserSubscriptionCategory?.DedicatedVM)"
        [isPaid]="!!mode"
        [paidDesc]="modeDesc">
      </db-one-month-free-checkout-demo>
    </div>

    <ng-container *ngIf="!animateSinglePlan" [ngTemplateOutlet]="intro"></ng-container>
  } @else {
    <!-- BUSINESS/ECOMMERCE VIEW -->
    <div *ngSwitchCase="'business'" class="db-business-ecommerce"
         [ngClass]="{'fade-out': showAgencyTab, 'fade-in': !showAgencyTab}">
      <div class="with-scroll" [ngClass]="{'active': animatePlans && !static, 'static': static, 'paid': !!mode}">
        <div class="db-one-week-free-demo">
          <div class="db-one-week-free-demo__header">
            @if (mode) {
              <div class="content paid">
                <h1>Upgrade to 10Web Pro</h1>
                <div class="db-desc mt8">
                  <div class="desc" [innerHTML]="modeDesc"></div>
                </div>
              </div>
            } @else {
              <div class="content">
                <h1>
                  <ng-container *ngIf="hasCouponForCampaign; else noCoupon">
                    Get
                    <ng-container *ngIf="(campaignInfo?.couponDays || couponDays) > 7">
                      <span class="db-days-lined">7 days</span>
                    </ng-container>

                    {{ campaignInfo?.couponDays == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays) + ' days' }} of
                    10Web Pro for free

                    <ng-container *ngIf="campaignInfo?.couponPercent || couponPercent">
                      &<br /> enjoy
                      <span [ngClass]="{ invisible: !campaignInfo?.couponPercent && !couponPercent }"
                            class="coupon-discount">
      {{ campaignInfo?.couponPercent || couponPercent }}% off </span>
                      for your first payment.
                    </ng-container>
                  </ng-container>

                  <ng-template #noCoupon>
                    {{ 'Get 7 days of 10Web Pro Plans and a custom domain for Free' }}
                  </ng-template>
                </h1>

              </div>
            }

            <div class="db-switch-with-tab mt18">
              <div class="db-tab-switcher">
                <div class="tab-option active">{{ activeTab === 'ecommerce' ? 'Ecommerce' : 'Business' }}</div>
                <div class="tab-option" (click)="seeAgencyTab(); addOwnWorkspace()">Agency (2+ websites)</div>
              </div>

              <!-- Period Switch Component -->
              <div class="db-period-switch-coupon db-upgrade-plan__period-switch" *ngIf="!isMobile && !singlePlanMode">
                <input class="ds-switcher-green ds-control-small"
                       type="checkbox"
                       [id]="'annual'"
                       [checked]="periodSwitch === 12">
                <label [for]="'annual'"
                       (click)="$event.preventDefault(); changePeriod()">
                  <p [class.monthly]="periodSwitch === 1">Annual discount (50%)</p>
                  <span class="ds-switcher-control"></span>
                </label>
              </div>
            </div>
          </div>

          <!-- Subscription Plans -->
          <div class="db-one-week-free-demo__content {{activeTab}} pt17 pl10">
            <ng-container *ngIf="subscriptionsTabs && subscriptionsTabs[activeTab]">
              <ng-container *ngFor="let subscription of subscriptionsTabs[activeTab]; let i = index">
                <db-one-week-free-demo-plan
                  [hasCampaignCoupon]="hasCouponForCampaign && !mode"
                  [showFirstTime]="showFirstTime"
                  [isPaid]="!!mode"
                  (proceedToCheckout)="proceedToCheckout($event)"
                  [isEcommerceWebsite]="isEcommerceWebsite"
                  [ngClass]="{
                    'two-columns': subscriptionsTabs[activeTab].length === 2 && activeTab === 'business' && !mode,
                    'hidden': subscription?.plan?.periodNumber !== periodSwitch,
                    'visible': subscription?.plan?.periodNumber === periodSwitch,
                    'last-child': i === subscriptionsTabs[activeTab].length - 1,
                    'selected': singlePlanMode || selectedPlanId === subscription.id
                  }"
                  [title]="subscription?.plan?.title"
                  [applyCouponForPlatform]="applyCouponForPlatform"
                  [couponPercent]="couponPercent"
                  [domainName]="domainName"
                  [hasFreeDays]="hasFreeDays"
                  [description]="planFeatures[activeTab][subscription?.category]?.desc"
                  [subscription]="subscription"
                  [periodSwitchValue]="periodSwitch"
                  [plan]="planFeatures[activeTab][subscription?.category]?.planInfo"
                  [planDesc]="planFeatures[activeTab][subscription?.category]?.planInfoDesc"
                  [mostPopular]="!!planFeatures[activeTab][subscription?.category]?.mostPopular"
                  [professionalInfo]="!!planFeatures[activeTab][subscription?.category]?.info"
                  [isAgency]="activeTab === 'agency'"
                  [activeTab]="activeTab"
                  [customDomainFlow]="customDomainFlow"
                  [isSelected]="singlePlanMode || selectedPlanId === subscription.id"
                  (onPlanChange)="selectPlan(subscription)">
                </db-one-week-free-demo-plan>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Proceed Button -->
      <ng-container [ngTemplateOutlet]="intro" *ngIf="!mode"></ng-container>
    </div>
  }

  <!-- AGENCY VIEW -->
  <div *ngSwitchCase="'agency'" [ngClass]="{'fade-in': showAgencyTab}" class="db-agency-wrap">
    <db-one-week-free-agency
      [higherPlan]="englishCountries"
      [singlePlanMode]="singlePlanMode && !mode"
      [hasCampaignCoupon]="hasCouponForCampaign"
      [isEcommerce]="activeTab === 'ecommerce'"
      [showFirstTime]="showFirstTime"
      [mode]="mode"
      [modeDesc]="modeDesc"
      [currentSubscription]="userSubscription"
      [couponPercent]="campaignInfo?.couponPercent || couponPercent"
      [couponDays]="campaignInfo?.couponDays || couponDays"
      (onPlanSelect)="proceedToCheckout($event); addOwnWorkspace()"
      (onBack)="currentView = 'business'; resizeToNormal()"></db-one-week-free-agency>
  </div>

  <!-- CHECKOUT VIEW -->
  <div *ngSwitchCase="'checkout'">
    <ng-container *ngIf="chosenPlan">
      <db-one-month-free-checkout-demo
        [userSubscription]="userSubscription"
        [expirationDate]="expirationDate"
        [user]="user"
        [demoUser]="demoUser"
        [chosenPlan]="chosenPlan"
        [couponCode]="couponCode"
        [couponPercent]="campaignInfo?.couponPercent || couponPercent"
        [couponDays]="campaignInfo?.couponDays || couponDays || 7"
        [hasCampaignCoupon]="hasCouponForCampaign && (chosenPlan?.category !== UserSubscriptionCategory?.DedicatedVM)"
        [isPaid]="!!mode"
        [paidDesc]="modeDesc"
        (onBack)="currentView = (['business', 'ecommerce'].includes(chosenPlan?.tabCategory) ? 'business' : 'agency'); resizeToNormal(chosenPlan?.tabCategory === 'agency')"
        (onClose)="closeModal($event)">
      </db-one-month-free-checkout-demo>
    </ng-container>

    <ng-container *ngIf="!mode && chosenPlan?.category !== UserSubscriptionCategory?.DedicatedVM"
                  [ngTemplateOutlet]="intro"></ng-container>
  </div>
</ng-container>


<ng-template #intro>
  <div class="trial-upgrade-container"
       [ngClass]="{'db-single-mode': singlePlanMode && !animateSinglePlan, 'db-onSide': animateRightSide && !navigatingBack, 'for-right': animateLeft && !navigatingBack, 'db-static-right': navigatingBack}">
    <div>
      <h1 class="title">How your Free Trial works</h1>

      <div class="timeline-steps" [@listAnimation]="showFirstTime ? 'active' : 'inactive'"
           (@listAnimation.done)="onAnimationDone($event)">
        <div *ngFor="let step of currentView === 'checkout' ? steps.slice(1) : steps; let i = index"
             class="timeline-step" [ngClass]="getStepClass(i, currentView === 'checkout')">
          <div class="step-icon">
            <i
              class="db-icon db-icon-{{(singlePlanMode && currentView === 'business' || currentView === 'ecommerce') ? step.icon_green || step.icon : step.icon}}"></i>
          </div>
          <div class="step-connector" *ngIf="i === 0">
            <svg xmlns="http://www.w3.org/2000/svg" width="2"
                 [attr.height]="currentView === 'checkout' ? '22' : showFirstTime ? '113' : '135'"
                 viewBox="0 0 2 113" fill="none">
              <path d="M1 0L1 113" stroke="singlePlanMode ? '#219653' : '#3339F1'' "/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="2"
                 [attr.height]="currentView === 'checkout' ? '157' : showFirstTime ? '269' : '328'"
                 viewBox="0 0 2 269" fill="none">
              <path d="M1 0L1.00001 269" stroke="black" stroke-opacity="0.2" stroke-dasharray="2 2"/>
            </svg>
          </div>
          <div class="step-content">
            <h3 class="step-title" [innerHTML]="(((singlePlanMode && currentView === 'business' || currentView === 'ecommerce') ? step?.title_green || step?.title : step?.title) || '')
 .replace('%6%', (campaignInfo?.couponDays || couponDays) ? ((campaignInfo?.couponDays || couponDays) - 1).toString() : '6')
 .replace('%7%', (campaignInfo?.couponDays || couponDays) ? (campaignInfo?.couponDays || couponDays).toString() : '7')
 .replace('%7days%',
  (campaignInfo?.couponDays || couponDays)
    ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' days')
    : '7 days'
)"></h3>
            <p class="step-description {{(campaignInfo?.couponDays || couponDays) == 30 }}"
               [innerHTML]="(singlePlanMode && currentView === 'business' || currentView === 'ecommerce')
   ? (hasCouponForCampaign && !!couponPercent
      ? ((step?.description_green_campaign || step?.description_green || step?.description) || '')
        .replace('%couponPercent%', campaignInfo?.couponPercent || couponPercent)
        .replace('%7freedays%', (campaignInfo?.couponDays || couponDays)
          ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' free days')
          : '7 free days')
        .replace('%7%',
          (campaignInfo?.couponDays || couponDays)
            ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' days')
            : '7 days'
        )
      : ((step?.description_green || step?.description) || '')
        .replace('%7%',
          (campaignInfo?.couponDays || couponDays)
            ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' days')
            : '7 days'
        )
        .replace('%7freedays%', (campaignInfo?.couponDays || couponDays)
          ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' free days')
          : '7 free days'))
   : (hasCouponForCampaign && !!couponPercent
      ? (currentView === 'checkout'
          ? ((step?.description_campaign_checkout || step?.description_checkout) || '')
            .replace('%couponPercent%', campaignInfo?.couponPercent || couponPercent)
            .replace('%7%',
              (campaignInfo?.couponDays || couponDays)
                ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' days')
                : '7 days'
            )
          : ((step?.description_campaign || step?.description) || '')
            .replace('%couponPercent%', campaignInfo?.couponPercent || couponPercent)
            .replace('%7freedays%', (campaignInfo?.couponDays || couponDays)
              ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' free days')
              : '7 free days')
            .replace('%7%',
              (campaignInfo?.couponDays || couponDays)
                ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' days')
                : '7 days'
            ))
      : (currentView === 'checkout'
          ? ((step?.description_checkout || step?.description) || '')
            .replace('%7%',
              (campaignInfo?.couponDays || couponDays)
                ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' days')
                : '7 days'
            )
          : ((step?.description) || '')
            .replace('%7%',
              (campaignInfo?.couponDays || couponDays)
                ? ((campaignInfo?.couponDays || couponDays) == 30 ? '1 month' : (campaignInfo?.couponDays || couponDays).toString() + ' free days')
                : '7 days'
            )))"></p>
          </div>
        </div>
      </div>

      <div class="stats-section" [ngClass]="{'db-checkout': animateLeft}">
        @if (animateLeft) {
          <db-carousel [template]="reviewCarouselRef" [items]="reviewers" [height]="116"></db-carousel>
          <div class="db-one-month-free-checkout-info__trust-pilot mt48">
            <div class="g2">
              <img src="assets/images/logos/services/g2_FI_2020.svg" alt="">
              <img src="assets/images/logos/services/g2_HP_2021.svg" alt="">
            </div>
            <db-trustpilot [class]="'db-booster-plan-checkout'"></db-trustpilot>
          </div>
        } @else {
          <p><span class="doted">1.5M+</span> websites created with 10Web AI.</p>
          <db-trustpilot [version]="'micro-combo'"></db-trustpilot>
        }
      </div>
    </div>

    <div>
      <p class="db-campaign-text mb20" *ngIf="(animateRightSide || navigatingBack) && hasCouponForCampaign && !!couponPercent">
        The {{ campaignInfo?.couponPercent || couponPercent }}% discount will be applied<br/> to your first payment,
        followed by<br/> standard {{chosenPlan?.type === 'month' ? 'monthly' : 'annual'}}  payments after that.</p>
      <!--      <a *ngIf="(animateRightSide || navigatingBack) && radioBtnVersion"
               class="ds-btn-black ds-btn-m-to-l rectangle"
               [ngClass]="{'disabled': !chosenPlan}"
               (click)="proceedToCheckout(chosenPlan); addOwnWorkspace()">
              <span>Try Free for {{ campaignInfo?.couponDays || couponDays}} Days</span>
            </a>-->
    </div>

  </div>
</ng-template>

<ng-template #reviewCarouselRef let-item='item'>
  <div class="db-one-month-free-checkout-info__carousel">
    <div class="mb8">
      <img src="{{item.img}}" alt="">
      <i [innerHTML]="'- ' + item.title"></i>
    </div>
    <p><i [innerHTML]="item.desc"></i></p>
  </div>
</ng-template>
